export default function Merge2048Icon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="10" fill="#1b3170" />
      <rect x="7" y="7" width="23" height="23" rx="5" fill="#ffd166" />
      <rect x="34" y="7" width="23" height="23" rx="5" fill="#ff7b6b" />
      <rect x="7" y="34" width="23" height="23" rx="5" fill="#41d48f" />
      <rect x="34" y="34" width="23" height="23" rx="5" fill="#c86bff" />
      <g fontFamily="Arial, sans-serif" fontWeight="900" textAnchor="middle" fill="#fff">
        <text x="18.5" y="24" fontSize="14" fill="#5a3a00">2</text>
        <text x="45.5" y="24" fontSize="14">4</text>
        <text x="18.5" y="51" fontSize="12" fill="#063a22">16</text>
        <text x="45.5" y="50" fontSize="9">2048</text>
      </g>
    </svg>
  );
}
